<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";

// Assuming usePage returns a reactive reference to the page object
const page = usePage(); // Assuming usePage is correctly imported
const questions = computed(() => page.value?.questions ?? []);
const answers = computed(() => page.value?.answers ?? []);

const startQuiz = ref(true);

// Setup reactive states for form elements
const question1 = ref<string | null>(null);
const question2 = ref<string | null>(null);
const question3 = ref<string | null>(null);

// Reactive state using the Composition API
const result0 = ref<boolean>(false);
const result1 = ref<boolean>(false);
const result2 = ref<boolean>(false);
const result3 = ref<boolean>(false);
const result4 = ref<boolean>(false);

// Codes for questions
const Q1Code = ref<string | null>(null);
const Q2Code = ref<string | null>(null);
const Q3Code = ref<string | null>(null);

function sortResults() {
  // Reset all results
  result0.value = false;
  result1.value = false;
  result2.value = false;
  result3.value = false;
  result4.value = false;

  //Results A's
  if (Q1Code.value === "A" && Q2Code.value === "A" && Q3Code.value === "A") {
    result0.value = true;
    console.log(result0.value);
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "A" &&
    Q3Code.value === "B"
  ) {
    result0.value = true;
    console.log(result0.value);
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "A" &&
    Q3Code.value === "C"
  ) {
    result0.value = true;
    console.log(result0.value);
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "A" &&
    Q3Code.value === "D"
  ) {
    result1.value = true;
    console.log(result1.value);
  }

  //Results A's & B's
  else if (
    Q1Code.value === "A" &&
    Q2Code.value === "B" &&
    Q3Code.value === "A"
  ) {
    result0.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "B" &&
    Q3Code.value === "B"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "B" &&
    Q3Code.value === "C"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "B" &&
    Q3Code.value === "D"
  ) {
    result1.value = true;
  }

  //Results A's & C's
  else if (
    Q1Code.value === "A" &&
    Q2Code.value === "C" &&
    Q3Code.value === "A"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "C" &&
    Q3Code.value === "B"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "C" &&
    Q3Code.value === "C"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "C" &&
    Q3Code.value === "D"
  ) {
    result1.value = true;
  }

  //Results A's & D's
  else if (
    Q1Code.value === "A" &&
    Q2Code.value === "D" &&
    Q3Code.value === "A"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "D" &&
    Q3Code.value === "B"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "D" &&
    Q3Code.value === "C"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "A" &&
    Q2Code.value === "D" &&
    Q3Code.value === "D"
  ) {
    result2.value = true;
  }

  //Results B's & A's
  else if (
    Q1Code.value === "B" &&
    Q2Code.value === "A" &&
    Q3Code.value === "A"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "A" &&
    Q3Code.value === "B"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "A" &&
    Q3Code.value === "C"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "A" &&
    Q3Code.value === "D"
  ) {
    result1.value = true;
  }

  //Results B's & B's
  else if (
    Q1Code.value === "B" &&
    Q2Code.value === "B" &&
    Q3Code.value === "A"
  ) {
    result0.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "B" &&
    Q3Code.value === "B"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "B" &&
    Q3Code.value === "C"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "B" &&
    Q3Code.value === "D"
  ) {
    result1.value = true;
  }

  //Results B's & C's
  else if (
    Q1Code.value === "B" &&
    Q2Code.value === "C" &&
    Q3Code.value === "A"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "C" &&
    Q3Code.value === "B"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "C" &&
    Q3Code.value === "C"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "C" &&
    Q3Code.value === "D"
  ) {
    result1.value = true;
  }

  //Results B's & D's
  else if (
    Q1Code.value === "B" &&
    Q2Code.value === "D" &&
    Q3Code.value === "A"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "D" &&
    Q3Code.value === "B"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "D" &&
    Q3Code.value === "C"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "B" &&
    Q2Code.value === "D" &&
    Q3Code.value === "D"
  ) {
    result2.value = true;
  }

  //Results C's & A's
  else if (
    Q1Code.value === "C" &&
    Q2Code.value === "A" &&
    Q3Code.value === "A"
  ) {
    result1.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "A" &&
    Q3Code.value === "B"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "A" &&
    Q3Code.value === "C"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "A" &&
    Q3Code.value === "D"
  ) {
    result2.value = true;
  }

  //Results C's & B's
  else if (
    Q1Code.value === "C" &&
    Q2Code.value === "B" &&
    Q3Code.value === "A"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "B" &&
    Q3Code.value === "B"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "B" &&
    Q3Code.value === "C"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "B" &&
    Q3Code.value === "D"
  ) {
    result2.value = true;
  }

  //Results C's & C's
  else if (
    Q1Code.value === "C" &&
    Q2Code.value === "C" &&
    Q3Code.value === "A"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "C" &&
    Q3Code.value === "B"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "C" &&
    Q3Code.value === "C"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "C" &&
    Q3Code.value === "D"
  ) {
    result2.value = true;
  }

  //Results C's & D's
  else if (
    Q1Code.value === "C" &&
    Q2Code.value === "D" &&
    Q3Code.value === "A"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "D" &&
    Q3Code.value === "B"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "D" &&
    Q3Code.value === "C"
  ) {
    result2.value = true;
  } else if (
    Q1Code.value === "C" &&
    Q2Code.value === "D" &&
    Q3Code.value === "D"
  ) {
    result2.value = true;
  }

  //Results D's & A's
  else if (
    Q1Code.value === "D" &&
    Q2Code.value === "A" &&
    Q3Code.value === "A"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "A" &&
    Q3Code.value === "B"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "A" &&
    Q3Code.value === "C"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "A" &&
    Q3Code.value === "D"
  ) {
    result3.value = true;
  }

  //Results D's & B's
  else if (
    Q1Code.value === "D" &&
    Q2Code.value === "B" &&
    Q3Code.value === "A"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "B" &&
    Q3Code.value === "B"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "B" &&
    Q3Code.value === "C"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "B" &&
    Q3Code.value === "D"
  ) {
    result3.value = true;
  }

  //Results D's & C's
  else if (
    Q1Code.value === "D" &&
    Q2Code.value === "C" &&
    Q3Code.value === "A"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "C" &&
    Q3Code.value === "B"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "C" &&
    Q3Code.value === "C"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "C" &&
    Q3Code.value === "D"
  ) {
    result3.value = true;
  }

  //Results D's & D's
  else if (
    Q1Code.value === "D" &&
    Q2Code.value === "D" &&
    Q3Code.value === "A"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "D" &&
    Q3Code.value === "B"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "D" &&
    Q3Code.value === "C"
  ) {
    result3.value = true;
  } else if (
    Q1Code.value === "D" &&
    Q2Code.value === "D" &&
    Q3Code.value === "D"
  ) {
    result4.value = true;
  }
}

// Watchers for question changes
watch(question1, (newValue1) => {
  console.log("question1 watcher triggered", newValue1);

  const trimmedValue = newValue1.trim();

  if (
    trimmedValue === "<p>You exercise <strong>on a daily basis</strong></p>"
  ) {
    Q1Code.value = "A";
    console.log(Q1Code.value);
  }
  if (
    trimmedValue === "<p>You exercise <strong>a few times a week</strong></p>"
  ) {
    Q1Code.value = "B";
    console.log(Q1Code.value);
  }
  if (
    trimmedValue ===
    "<p>You do <strong>some exercise but not on a regular basis</strong></p>"
  ) {
    Q1Code.value = "C";
    console.log(Q1Code.value);
  }
  if (
    trimmedValue === "<p>You <strong>don’t take regular exercise</strong></p>"
  ) {
    Q1Code.value = "D";
    console.log(Q1Code.value);
  }

  sortResults();
});

watch(question2, (newValue2) => {
  console.log("question2 watcher triggered", newValue2);
  const trimmedValue = newValue2.trim();
  if (
    trimmedValue ===
    "<p>You <strong>regularly walk in the mountains in your home country</strong></p>"
  ) {
    Q2Code.value = "A";
    console.log(Q2Code.value);
  }
  if (
    trimmedValue ===
    "<p>You <strong>regularly walk, sometimes in the mountains</strong></p>"
  ) {
    Q2Code.value = "B";
    console.log(Q2Code.value);
  }
  if (
    trimmedValue ===
    "<p>You do <strong>some walking and have walked in the mountains before</strong></p>"
  ) {
    Q2Code.value = "C";
    console.log(Q2Code.value);
  }
  if (
    trimmedValue ===
    "<p>You <strong>haven’t walked in the mountains for a number of years</strong> or <strong>haven't walked in the mountains before</strong></p>"
  ) {
    Q2Code.value = "D";
    console.log(Q2Code.value);
  }
  sortResults();
});

watch(question3, (newValue3) => {
  const trimmedValue = newValue3.trim();
  console.log("question3 watcher triggered", newValue3);
  if (
    trimmedValue ===
    "<p>You take <strong>a trekking holiday every year</strong></p>"
  ) {
    Q3Code.value = "A";
    console.log(Q3Code.value);
  } else if (
    trimmedValue ===
    "<p>You have taken <strong>trekking holidays in recent years and coped well</strong></p>"
  ) {
    Q3Code.value = "B";
    console.log(Q3Code.value);
  } else if (
    trimmedValue ===
    "<p>You have taken <strong>a trekking holiday before but not for many years</strong></p>"
  ) {
    Q3Code.value = "C";
    console.log(Q3Code.value);
  } else if (
    trimmedValue ===
    "<p>You have <strong>never taken a trekking holiday before</strong></p>"
  ) {
    Q3Code.value = "D";
    console.log(Q3Code.value);
  }
  sortResults();
});

onMounted(() => {
  console.log("Quiz data loaded:", questions.value);
});
</script>

<template>
  <div id="questionnaire">
    <div id="qWrapper">
      <TransitionGroup name="slideup" appear>
        <div v-for="question in questions.slice(0, 1)" :key="question.question">
          <div v-if="startQuiz && question1 == null" id="Q1" class="question">
            <h3>{{ question.question }}</h3>
            <div class="radio-group">
              <div class="form-control">
                <input
                  id="Q1-answer1"
                  v-model="question1"
                  type="radio"
                  name="question1"
                  :value="question.answer1"
                />
                <label for="Q1-answer1" v-html="question.answer1" />
              </div>
              <div class="form-control">
                <input
                  id="Q1-answer2"
                  v-model="question1"
                  type="radio"
                  name="question1"
                  :value="question.answer2"
                />
                <label for="Q1-answer2" v-html="question.answer2" />
              </div>
              <div class="form-control">
                <input
                  id="Q1-answer3"
                  v-model="question1"
                  type="radio"
                  name="question1"
                  :value="question.answer3"
                />
                <label for="Q1-answer3" v-html="question.answer3" />
              </div>
              <div class="form-control">
                <input
                  id="Q1-answer4"
                  v-model="question1"
                  type="radio"
                  name="question1"
                  :value="question.answer4"
                />
                <label for="Q1-answer4" v-html="question.answer4" />
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
      <TransitionGroup name="slideup" appear>
        <div
          v-if="question1 != null && question2 == null"
          id="Q2"
          class="question"
        >
          <div
            v-for="question in questions.slice(1, 2)"
            v-cloak
            :key="question.question"
          >
            <div id="Q2">
              <h3>{{ question.question }}</h3>
              <div class="radio-group">
                <div class="form-control">
                  <input
                    id="Q2-answer1"
                    v-model="question2"
                    type="radio"
                    name="question2"
                    :value="question.answer1"
                  />
                  <label for="Q2-answer1" v-html="question.answer1" />
                </div>
                <div class="form-control">
                  <input
                    id="Q2-answer2"
                    v-model="question2"
                    type="radio"
                    name="question2"
                    :value="question.answer2"
                  />
                  <label for="Q2-answer2" v-html="question.answer2" />
                </div>
                <div class="form-control">
                  <input
                    id="Q2-answer3"
                    v-model="question2"
                    type="radio"
                    name="question2"
                    :value="question.answer3"
                  />
                  <label for="Q2-answer3" v-html="question.answer3" />
                </div>
                <div class="form-control">
                  <input
                    id="Q2-answer4"
                    v-model="question2"
                    type="radio"
                    name="question2"
                    :value="question.answer4"
                  />
                  <label for="Q2-answer4" v-html="question.answer4" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
      <TransitionGroup name="slideup" appear>
        <div
          v-if="question2 != null && question3 == null"
          id="Q3"
          class="question"
        >
          <div
            v-for="question in questions.slice(2, 3)"
            v-cloak
            :key="question.question"
          >
            <div id="Q3">
              <h3>{{ question.question }}</h3>
              <div class="radio-group">
                <div class="form-control">
                  <input
                    id="Q3-answer1"
                    v-model="question3"
                    type="radio"
                    name="question3"
                    :value="question.answer1"
                  />
                  <label for="Q3-answer1" v-html="question.answer1" />
                </div>
                <div class="form-control">
                  <input
                    id="Q3-answer2"
                    v-model="question3"
                    type="radio"
                    name="question3"
                    :value="question.answer2"
                  />
                  <label for="Q3-answer2" v-html="question.answer2" />
                </div>
                <div class="form-control">
                  <input
                    id="Q3-answer3"
                    v-model="question3"
                    type="radio"
                    name="question3"
                    :value="question.answer3"
                  />
                  <label for="Q3-answer3" v-html="question.answer3" />
                </div>
                <div class="form-control">
                  <input
                    id="Q3-answer4"
                    v-model="question3"
                    type="radio"
                    name="question3"
                    :value="question.answer4"
                  />
                  <label for="Q3-answer4" v-html="question.answer4" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
    <TransitionGroup v-cloak name="slideup" appear>
      <div v-if="question3 != null" id="qResponses">
        <div class="response">
          <span> 1. </span>
          <span
            v-if="question1 != null"
            class="first-line"
            v-html="question1"
          />
        </div>
        <div class="response">
          <span>2.</span>
          <div v-if="question2 != null" v-html="question2" />
        </div>

        <div class="response">
          <span>3.</span>
          <div v-if="question3 != null" v-html="question3" />
        </div>
      </div>
    </TransitionGroup>

    <div v-if="question3 != null" id="qResults">
      <Transition v-cloak name="slideup" mode="out-in">
        <div v-if="result0" key="result0" class="result">
          <div v-for="response in answers.slice(0, 1)" :key="response">
            <div v-html="response.response"></div>
          </div>
        </div>
      </Transition>

      <Transition v-cloak name="slideup" mode="out-in">
        <div v-if="result1" key="result1" class="result">
          <div v-for="response in answers.slice(1, 2)" :key="response">
            <div v-html="response.response"></div>
          </div>
        </div>
      </Transition>

      <Transition v-cloak name="slideup" mode="out-in">
        <div v-if="result2" key="result2" class="result">
          <div v-for="response in answers.slice(2, 3)" :key="response">
            <div v-html="response.response"></div>
          </div>
        </div>
      </Transition>

      <Transition v-cloak name="slideup" mode="out-in">
        <div v-if="result3" key="result3" class="result">
          <div v-for="response in answers.slice(3, 4)" :key="response">
            <div v-html="response.response"></div>
          </div>
        </div>
      </Transition>

      <Transition v-cloak name="slideup" mode="out-in">
        <div v-if="result4" key="result4" class="result">
          <div v-for="response in answers.slice(4, 5)" :key="response">
            <div v-html="response.response"></div>
          </div>
        </div>
      </Transition>
    </div>
  </div>
  <div id="quizImages">
    <Transition v-cloak name="slideup" mode="out-in">
      <NuxtPicture
        v-if="startQuiz && question1 == null"
        format="webp"
        loading="lazy"
        src="/images/quiz/quiz-image1.jpg"
        width="400"
        height="400"
        alt="Hikers"
        sizes="sm:200px md:300px lg:400px"
      />
    </Transition>
    <Transition v-cloak name="slideup" mode="out-in">
      <NuxtPicture
        v-if="question1 != null && question2 == null"
        format="webp"
        loading="lazy"
        src="/images/quiz/quiz-image2.jpg"
        width="400"
        height="400"
        alt="Hikers"
        sizes="sm:200px md:300px lg:400px"
      />
    </Transition>
    <Transition v-cloak name="slideup" mode="out-in">
      <NuxtPicture
        v-if="question2 != null && question3 == null"
        format="webp"
        loading="lazy"
        src="/images/quiz/quiz-image3.jpg"
        width="400"
        height="400"
        alt="Hikers"
        sizes="sm:200px md:300px lg:400px"
      />
    </Transition>
    <Transition v-cloak name="slideup" mode="out-in">
      <NuxtPicture
        v-if="question3 != null"
        format="webp"
        loading="lazy"
        src="/images/quiz/quiz-image4.jpg"
        width="400"
        height="400"
        alt="Hikers"
        sizes="sm:200px md:300px lg:400px"
      />
    </Transition>
  </div>
</template>
